"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureFlagManager = exports.FeatureFlagManager = exports.FeatureFlags = exports.FeatureFlagName = exports.isFeatureFlagEnabled = void 0;
// Determine whether feature flag is enabled based on environment variable setting
function isFeatureFlagEnabled(featureFlagName, defaultValue = false) {
    const flag = process.env[featureFlagName];
    if (flag === undefined) {
        return defaultValue; // allows consumer to set a default value when environment variable not set
    }
    else {
        return flag === "1" || flag.toLowerCase() === "true"; // can enable feature flag by set environment variable value to "1" or "true"
    }
}
exports.isFeatureFlagEnabled = isFeatureFlagEnabled;
class FeatureFlagName {
}
exports.FeatureFlagName = FeatureFlagName;
FeatureFlagName.CLIDotNet = "TEAMSFX_CLI_DOTNET";
FeatureFlagName.OfficeMetaOS = "TEAMSFX_OFFICE_METAOS";
FeatureFlagName.SampleConfigBranch = "TEAMSFX_SAMPLE_CONFIG_BRANCH";
FeatureFlagName.TestTool = "TEAMSFX_TEST_TOOL";
FeatureFlagName.METestTool = "TEAMSFX_ME_TEST_TOOL";
FeatureFlagName.TeamsFxRebranding = "TEAMSFX_REBRANDING";
FeatureFlagName.TdpTemplateCliTest = "TEAMSFX_TDP_TEMPLATE_CLI_TEST";
FeatureFlagName.AsyncAppValidation = "TEAMSFX_ASYNC_APP_VALIDATION";
FeatureFlagName.NewProjectType = "TEAMSFX_NEW_PROJECT_TYPE";
FeatureFlagName.ChatParticipant = "TEAMSFX_CHAT_PARTICIPANT";
FeatureFlagName.ChatParticipantUIEntries = "TEAMSFX_CHAT_PARTICIPANT_ENTRIES";
FeatureFlagName.HideGitHubCopilotPreviewTag = "TEAMSFX_HIDE_GITHUB_COPILOT_PREVIEW_TAG";
FeatureFlagName.SMEOAuth = "SME_OAUTH";
FeatureFlagName.ShowDiagnostics = "TEAMSFX_SHOW_DIAGNOSTICS";
FeatureFlagName.TelemetryTest = "TEAMSFX_TELEMETRY_TEST";
FeatureFlagName.DevTunnelTest = "TEAMSFX_DEV_TUNNEL_TEST";
FeatureFlagName.SyncManifest = "TEAMSFX_SYNC_MANIFEST";
FeatureFlagName.KiotaIntegration = "TEAMSFX_KIOTA_INTEGRATION";
FeatureFlagName.KiotaNPMIntegration = "TEAMSFX_KIOTA_NPM_INTEGRATION";
FeatureFlagName.CEAEnabled = "TEAMSFX_CEA_ENABLED";
FeatureFlagName.BuilderAPIEnabled = "TEAMSFX_BUILDER_API";
FeatureFlagName.EmbeddedKnowledgeEnabled = "TEAMSFX_EMBEDDED_KNOWLEDGE";
FeatureFlagName.ShareEnabled = "TEAMSFX_SHARE";
FeatureFlagName.AddODSPKnowledge = "TEAMSFX_ADD_ODSP_KNOWLEDGE";
FeatureFlagName.SandBoxedTeam = "TEAMSFX_SANDBOXED_TEAM";
FeatureFlagName.SensitivityLabelEnabled = "TEAMSFX_SENSITIVITY_LABEL";
FeatureFlagName.DAMetaOS = "TEAMSFX_DA_METAOS";
class FeatureFlags {
}
exports.FeatureFlags = FeatureFlags;
FeatureFlags.CLIDotNet = { name: FeatureFlagName.CLIDotNet, defaultValue: "false" };
FeatureFlags.TestTool = { name: FeatureFlagName.TestTool, defaultValue: "true" };
FeatureFlags.METestTool = { name: FeatureFlagName.METestTool, defaultValue: "true" };
FeatureFlags.OfficeMetaOS = {
    name: FeatureFlagName.OfficeMetaOS,
    defaultValue: "true",
};
FeatureFlags.TdpTemplateCliTest = {
    name: FeatureFlagName.TdpTemplateCliTest,
    defaultValue: "false",
};
FeatureFlags.AsyncAppValidation = {
    name: FeatureFlagName.AsyncAppValidation,
    defaultValue: "true",
};
FeatureFlags.NewProjectType = { name: FeatureFlagName.NewProjectType, defaultValue: "true" };
FeatureFlags.ChatParticipant = {
    name: FeatureFlagName.ChatParticipant,
    defaultValue: "false",
};
FeatureFlags.ChatParticipantUIEntries = {
    name: FeatureFlagName.ChatParticipantUIEntries,
    defaultValue: "false",
};
FeatureFlags.HideGitHubCopilotPreviewTag = {
    name: FeatureFlagName.HideGitHubCopilotPreviewTag,
    defaultValue: "false",
};
FeatureFlags.SMEOAuth = { name: FeatureFlagName.SMEOAuth, defaultValue: "false" };
FeatureFlags.ShowDiagnostics = {
    name: FeatureFlagName.ShowDiagnostics,
    defaultValue: "false",
};
FeatureFlags.TelemetryTest = {
    name: FeatureFlagName.TelemetryTest,
    defaultValue: "false",
};
FeatureFlags.DevTunnelTest = {
    name: FeatureFlagName.DevTunnelTest,
    defaultValue: "false",
};
FeatureFlags.SyncManifest = {
    name: FeatureFlagName.SyncManifest,
    defaultValue: "false",
};
FeatureFlags.KiotaIntegration = {
    name: FeatureFlagName.KiotaIntegration,
    defaultValue: "false",
};
FeatureFlags.KiotaNPMIntegration = {
    name: FeatureFlagName.KiotaNPMIntegration,
    defaultValue: "true",
};
FeatureFlags.CEAEnabled = {
    name: FeatureFlagName.CEAEnabled,
    defaultValue: "false",
};
FeatureFlags.BuilderAPIEnabled = {
    name: FeatureFlagName.BuilderAPIEnabled,
    defaultValue: "false",
};
FeatureFlags.EmbeddedKnowledgeEnabled = {
    name: FeatureFlagName.EmbeddedKnowledgeEnabled,
    defaultValue: "false",
};
FeatureFlags.ShareEnabled = {
    name: FeatureFlagName.ShareEnabled,
    defaultValue: "false",
};
FeatureFlags.AddODSPKnowledge = {
    name: FeatureFlagName.AddODSPKnowledge,
    defaultValue: "true",
};
FeatureFlags.SandBoxedTeam = {
    name: FeatureFlagName.SandBoxedTeam,
    defaultValue: "false",
};
FeatureFlags.SensitivityLabelEnabled = {
    name: FeatureFlagName.SensitivityLabelEnabled,
    defaultValue: "false",
};
FeatureFlags.DAMetaOS = {
    name: FeatureFlagName.DAMetaOS,
    defaultValue: "false",
};
class FeatureFlagManager {
    getBooleanValue(featureFlag) {
        return isFeatureFlagEnabled(featureFlag.name, featureFlag.defaultValue === "true" || featureFlag.defaultValue === "1");
    }
    setBooleanValue(featureFlag, value) {
        process.env[featureFlag.name] = value ? "true" : "false";
    }
    getStringValue(featureFlag) {
        return process.env[featureFlag.name] || featureFlag.defaultValue;
    }
    list() {
        return Object.values(FeatureFlags);
    }
    listEnabled() {
        return this.list()
            .filter((f) => isFeatureFlagEnabled(f.name))
            .map((f) => f.name);
    }
}
exports.FeatureFlagManager = FeatureFlagManager;
exports.featureFlagManager = new FeatureFlagManager();
//# sourceMappingURL=featureFlags.js.map